import { isElementInViewport } from '@theme/utilities';

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.form = null;
    this.atcButton = null;
    this.footer = null;
    this.#scrollHandler = this.#scrollHandler.bind(this);
    this._rafPending = false;
  }

  connectedCallback() {
    this.form = this.closest('[data-ref="product-form"]');
    this.footer = document.querySelector('[data-ref="footer"]');
    this.atcButton = this.form?.querySelector('[data-ref="add-to-cart-button"]');

    this.#displayStickyAddToCart();

    window.addEventListener('scroll', this.#scrollHandler, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.#scrollHandler);
  }

  #scrollHandler() {
    if (this._rafPending) return;
    this._rafPending = true;
    requestAnimationFrame(() => {
      this.#displayStickyAddToCart();
      this._rafPending = false;
    });
  }

  #displayStickyAddToCart() {
    const target = this.atcButton || this.form;
    if (window.scrollY === 0 || isElementInViewport(target) || isElementInViewport(this.footer)) {
      this.dataset.active = 'false';
      this.classList.remove('color-scheme-1');
    } else {
      this.dataset.active = 'true';
      this.classList.add('color-scheme-1');
    }
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
